import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HashService {

  constructor() { }

  async sha256(s) {
    if (isSecureContext) {
      return await crypto.subtle.digest("SHA-256", s);
    }
    throw new Error("The current context is not secure");
  }
}
